import React from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import Placeholder from '@atlassian/jira-placeholder';

import type FeedbackCollectorRenderer from './index';

// Note `renderer` here means a small wrapper/boilerplate which is used
// to render AK Feedback Collector dialog later.

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyFeedbackCollectorRenderer = lazyAfterPaint<typeof FeedbackCollectorRenderer>(
	() => import(/* webpackChunkName: "async-feedback-collector-renderer" */ './index'),
	{ ssr: false },
);

export const AsyncFeedbackCollectorRenderer = () => (
	<JSErrorBoundary id="asyncFeedbackCollector" packageName="jiraFeedbackCollector" teamName="magma">
		<Placeholder name="async-feedback-collector-renderer" fallback={null}>
			<LazyFeedbackCollectorRenderer />
		</Placeholder>
	</JSErrorBoundary>
);
